import React, {ReactElement, useEffect, useRef, useState} from "react";
import {PageSpinner} from "../../components/com/pagesTab/pagesSpinner/spinner";
import {Box} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {FlyerPageSpotDto} from "../../dtos";

const useStyles = makeStyles(() => ({
    imageWrapper: (props: any) => ({
        width: `100%`,
        height: `100%`,
        maxWidth: `inherit`,
        maxHeight: `inherit`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        borderRadius: `inherit`,
        '& > svg': {
            maxWidth: `inherit`,
            maxHeight: `inherit`,
            width: `100%`,
            height: `100%`,
            padding: props.withoutLoader ? `20px` : `2px`,
        }
    }),
    image: (props: any) => ({
        maxWidth: `inherit`,
        maxHeight: `inherit`,
        // padding: `2px`,
        border: props.withBorders ? "1px solid #e4e4e4" : "none",
        padding: "1px"
    }),
    hideImage: {
        display: `none`,
    }
}))

interface Props {
    src: string;
    notUploadIcon?: ReactElement;
    loadImageCallback?: (isLoad: boolean) => void;
    withoutLoader?: boolean;
    selectedPageImage?: string;
    frame?: FlyerPageSpotDto;
    withBorders?: boolean;
}

export const AsyncImageWithLoader = (props: Props) => {
    const [didLoad, onLoad] = useState(false);
    const [notLoad, onNotLoad] = useState(false);
    const canvasRef = useRef(null)

    const stylesProperties = {
        withoutLoader: props.withoutLoader,
        withBorders: props.withBorders || false
    }
    const classes = useStyles(stylesProperties);

    useEffect(() => {
        onLoad(false);
        // if (props.src) {
        const handleLoad = () => {
            onLoad(true);
            onNotLoad(false);
        };
        const handleError = () => {
            onNotLoad(true);
            if (props.loadImageCallback) {
                props.loadImageCallback(false);
            }
        };
        const image = new Image();
        if (props.frame && props.src === `frameImage${props.frame.fpsRecId}`) {
            const canvasContainer = canvasRef.current as HTMLCanvasElement | null;
            if (canvasContainer && props.selectedPageImage && props.frame) {
                const ctx = canvasContainer.getContext("2d");
                canvasContainer.style.width = '100%';
                canvasContainer.style.height = '100%';
                canvasContainer.width = canvasContainer.offsetWidth;
                canvasContainer.height = canvasContainer.offsetHeight;
                image.src = props.selectedPageImage;
                image.addEventListener('load', () => {
                    if (ctx && props.frame) {
                        let imgWidth = props.frame.fpsWidthPx!;
                        let screenWidth = canvasContainer.width;
                        let scaleX = screenWidth / imgWidth;
                        let imgHeight = props.frame.fpsHeightPx!;
                        let screenHeight = canvasContainer.height;
                        let scaleY = screenHeight / imgHeight;
                        let scale = scaleY;
                        if (scaleX < scaleY) {
                            scale = scaleX;
                        }
                        imgHeight = imgHeight * scale;
                        imgWidth = imgWidth * scale;
                        canvasContainer.style.width = `${imgWidth}px`;
                        canvasContainer.style.height = `${imgHeight}px`;
                        canvasContainer.height = imgHeight;
                        canvasContainer.width = imgWidth;


                        ctx.drawImage(
                            image,
                            props.frame.fpsX0px!, //x0
                            props.frame.fpsY0px!, // y0 Start at 70/20 pixels from the left and the top of the image (crop),
                            props.frame.fpsWidthPx!, //x1 - x0
                            props.frame.fpsHeightPx!, //y1 - y0 "Get" a `50 * 50` (w * h) area from the source image (crop),
                            0,
                            0, // Place the result at 0, 0 in the canvas,
                            // 100 * props.frame.fpsWidthPx! / props.frame.fpsHeightPx!,
                            // 100 * props.frame.fpsHeightPx! / props.frame.fpsWidthPx!
                            imgWidth,
                            imgHeight
                        ); // With as width / height: 100 * 100 (scale)

                    }
                })
            }
        } else {
            image.addEventListener('load', handleLoad);
            image.addEventListener('error', handleError);
            image.src = props.src;
        }

        return () => {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        };
    }, [props.src]);

    if (props.frame && props.src === `frameImage${props.frame.fpsRecId}`) {
        return (
            <canvas ref={canvasRef} style={{
                maxWidth: 'inherit',
                maxHeight: 'inherit',
                cursor: 'pointer'
            }}></canvas>
        )
    }

    return (
        <Box className={classes.imageWrapper} id={'imageWrapper'} sx={{
            cursor: props.src !== '' ? `pointer` : `default`,
            backgroundColor: !didLoad && notLoad ? '#ffffff' : `transparent`
        }}>
            <img className={`${didLoad && !notLoad ? '' : classes.hideImage} ${classes.image}`}
                 src={props.src}
                 alt={`don't upload`}
            />
            {
                !didLoad && !notLoad && !props.withoutLoader && <PageSpinner/>
            }
            {notLoad && props.notUploadIcon && props.notUploadIcon}
        </Box>
    )
}